import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  btnActive: {
    fontWeight: 400,
    backgroundColor: theme.palette.secondary.pink,
    color: theme.palette.white.main,
    border: 0,
    height: 40,
    borderRadius: 5,
    fontFamily: 'Red Hat Display Bold',

    '&:hover': {
      backgroundColor: theme.palette.secondary.pink,
    },
  },
  btnNotActive: {
    fontWeight: 400,
    height: 40,
    border: '1px solid black',
    borderRadius: 5,
    color: theme.palette.black.main,
    fontFamily: 'Red Hat Display Bold',
  },
  fltContainer: {
    position: 'relative',
  },
  quantityLabel: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    borderRadius: '50%',
    background: '#6064FF',
    color: 'white',
    lineHeight: '0.5',
    padding: '10px',
    fontSize: '10px',
    fontWeight: 'bold',
    zIndex: 1,
  },
  filterInput: {
    margin: 0,
    minWidth: '270px',
  },
  chip: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1), // para separación del input
    backgroundColor: '#5e44ff',
    color: '#fff',
    height: 28,
    fontSize: 13,
    '& .MuiChip-deleteIcon': {
      color: '#fff',
      opacity: 0.7,
    },
  },
  liReset: {
    listStyle: 'none',
    '&::marker': {
      display: 'none',
    },
  },
}))
